<div class="collections-container">
  <h1>Collections</h1>
  <div class="options-menu">
    <mat-form-field appearance="outline" color="accent" class="search-field" (click)="clearInputText()">
      <input
        type="text"
        placeholder="Select collection"
        matInput
        [matAutocomplete]="auto"
        [(ngModel)]="collectionInput"
        (input)="filterCollections($event)"
        (keydown.enter)="selectTopCollection($event)"
        #autocompleteTrigger="matAutocompleteTrigger" />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn.bind(this)"
        (optionSelected)="setCollection($event.option.value)">
        <mat-option *ngFor="let collection of filteredCollections" [value]="collection">
          {{ collection.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <div class="right-options">
      <button mat-button (click)="openResearchPromptDialog()" [disabled]="!hasFilterOptions">
        <mat-icon>list</mat-icon>
        <span class="spacer"></span>
        Research
      </button>
      <button
        mat-button
        [disabled]="!hasFilterOptions"
        matTooltip="View research jobs"
        (click)="openViewResearchDialog()">
        <mat-icon>list</mat-icon>
        <span class="spacer"></span>
        View Research
      </button>
      <button mat-button (click)="openFilterModal()" [disabled]="!hasFilterOptions">
        <mat-icon>list</mat-icon>
        <span class="spacer"></span>
        Filters ({{ filterCount }})
      </button>
      <mat-form-field appearance="outline" color="accent" class="search-field">
        <mat-label>Search</mat-label>
        <input matInput matTooltip="Filter documents" placeholder="Search..." (input)="onQuickFilterChanged($event)" />
      </mat-form-field>
    </div>
  </div>
  <div class="table-container">
    <ag-grid-angular
      #agGrid
      [theme]="theme"
      style="height: 100%"
      [rowData]="filteredRowData"
      [pinnedTopRowData]="pinnedTopRows"
      [columnDefs]="colDefs"
      [animateRows]="true"
      [enableBrowserTooltips]="true">
    </ag-grid-angular>
  </div>
</div>
